export const Anais = [
  {
    title: 'ANÁLISE DE IMAGENS PARA A QUANTIFICAÇÃO DE COLÔNIAS DE BACTÉRIAS',
    autor: 'Silva, E. R.',
    path: '/assets/anais/Image Analysis for Quantifying Bacterial Colonies.pdf'    
  },
  {
    title: 'ANÁLISE DO FID NA RESSONÂNCIA MAGNÉTICA POR IMAGEAMENTO',
    autor: 'Araújo, G.',
    path: '/assets/anais/ANÁLISE DO FID NA RESSONÂNCIA MAGNÉTICA POR IMAGEAMENTO_pronto.pdf'    
    
  },
  {
    title: 'ANÁLISE NODAL DE CIRCUITO ELÉTRICO EMPREGANDO COMPUTAÇÃO PARALELA GPU CUDA',
    autor: 'Machado, B.S.',
    path: '/assets/anais/JCECEC_Bierley (1).pdf'    

  },
  {
    title: 'AVALIAÇÃO DE IMPLEMENTAÇÕES DE ALGORITMOS GENÉTICOS NA ESTIMAÇÃO DOA',
    autor: 'Neto, A. A. S.',
    path: '/assets/anais/AVALIAÇÃO DE IMPLEMENTAÇÕES DE ALGORITMOS GENÉTICOS NA ESTIMAÇÃO DOA.pdf'    

  },
  {
    title: 'DETECÇÃO DE DISCOS DE ANTIBIÓTICOS EM IMAGENS DE TESTE DE DISCO-DIFUSÃO (KIRBY-BAUER) UTILIZANDO REDES NEURAIS CONVOLUCIONAIS',
    autor: 'Nascimento, V. D.',
    path: '/assets/anais/Detecção (1).pdf'    

  },
  {
    title: 'ESTRATÉGIA DE CONTROLE PARA A OPERAÇÃO ÓTIMA DO RESERVATÓRIO DA USINA HIDRELÉTRICA DE JIRAU UTILIZANDO OTIMIZAÇÃO NÃO LINEAR',
    autor: 'Brandão Filho, R. C.',
    path: '/assets/anais/JCECEC_Rone _Vf_pronto.pdf'    

  },
  {
    title: 'IDENTIFICAÇÃO DE ERROS NA LISTA DE CONECTIVIDADE DE CIRCUITO ELÉTRICO EMPREGANDO ANALISADOR LÉXICO E SINTÁTICO',
    autor: 'Sousa, G. T. A.',
    path: '/assets/anais/JCECEC_Gabriel_pronto.pdf'      
  },
  {
    title: 'MODELAGEM DE SISTEMA DE PARTIDA E PARADA DE UMA TURBINA HIDRELÉTRICA USANDO REDES PETRI',
    autor: 'Silva, C. O.',
    path: '/assets/anais/MODELAGEM DE SISTEMA DE PARTIDA E PARADA EM REDES PETRI (1).pdf'
  },
  {
    title: 'PREDIÇÃO DA ALTURA DE QUEDA DA USINA DE JIRAU UTILIZANDO REDES NEURAIS ARTIFICIAIS RECORRENTES LSTM',
    autor: 'Silva, D. F. C.',
    path: '/assets/anais/Diogof_pronto.pdf'    
  },
  {
    title: 'Simulador de Testes Adaptativos Baseado na Proficiência do Aluno',
    autor: 'Brandão, H. M. de L.',
    path: '/assets/anais/Leonardo_pronto.pdf'    

  },
    
]

/*Exportar aqui os anais da JCPOLI V, para exportar os anais da JCPOLIVI criar outro export e referenciar esse export em Anais.VUE*/
export const Anais2 = [
  {
    title: 'ESTUDO DA VARIABILIDADE NO TEMPO DE EXECUÇÃO COM MAPA DE FLUXO DE VALOR',
    autor: 'Fraga, S. S, Mendes, G. M. & Rodrigues, P. B. F.',
    path: '/assets/anais/suellen.pdf'
  },{
    title: 'ESTUDO DA VIABILIDADE TECNICA DO USO DE BLOCOS DE CONCRETO PERMEÁVEIS COMO ALTERNATIVA PARA A REDUÇÃO DO ESCOAMENTO SUPERFICIAL NO MUNICÍPIO DE GOIÂNIA',
    autor: 'Gomes, I. M. Queiroz, J.J.D.F',
    path: '/assets/anais/joão.pdf'
  },  

]

export const Anais3 = [
  {
    title: 'Análise Preditiva com Redes Neurais Convolucionais Para o Geoprocessamentoo de Imagens',
    autor: 'Cavalcante, E. S, Sousa, M. A',
    path: '/assets/anais/redesneurais.pdf'
  },
  {
    title: 'Uso das normas NBR ISO-IEC 27017 e 27018 para garantir a segurança da computação em nuvem',
    autor: 'Souza, H, Silva, S.',
    path: '/assets/anais/usodasnormas.pdf'
  },

]

export const livros = [
  {
    title: 'PLANEJAMENTO E CONTROLE DE OBRA INTEGRADO AO BIM, COM FOCO NO PROCESSO DE CONHECIMENTO',
    autor: `MARQUES, A. C. A. & SILVA, S.`,
    path: 'https://studiespublicacoes.com.br/cat.php?bk=VDQ2zh9Z9288v5lHuXE1G4jyaS60Wr37'
  },
    
]

//Dps que houver as publicações da "APRESENTAÇÃO DOS ARTIGOS APROVADOS PARA A III JCPOLI", subistituir o file no path
export const AnaisJCPOLI3 = [
  {
    title: 'Os biocombustíveis e a inovação de ruptura na aviação civil',
    autor: 'Nathan Santana do Couto Souza',
    path: '' 
  },
  {
    title: 'Protegendo saúde digital: ajustando IOT à LGPD para privacidade',
    autor: 'Matheus Rodrigues Tenaglia',
    path: ''
  },
  {
    title: 'Monitoramento de redes de computadores utilizando grafana',
    autor: 'Gabriel Castro Gonçalves',
    path: ''
  },
  {
    title: 'Indústrira 4.0: digitalização de fábricas, sistemas de monitoramento, coleta de dados e automação',
    autor: 'Gabriel Sales Mendes da Silva',
    path: ''
  },
]
